import { apiClient } from '../utils/api';

interface IapSyncResponse {
  synced: boolean;
  status?: 'active' | 'trialing' | 'expired' | 'none';
  planType?: string;
  periodEnd?: string | null;
  reason?: string;
}

/**
 * Tell the backend to pull this user's subscription state from RevenueCat
 * and reconcile our `premium_subscriptions` table. Called after a successful
 * purchase/restore so that the next `/api/user/entitlement` read sees the
 * new state — without depending on the RC webhook arriving in time.
 *
 * Failures are swallowed: if this call fails the user can still tap Restore
 * Purchases later, and the next entitlement refresh will retry implicitly via
 * the webhook path.
 */
export async function syncIapWithBackend(): Promise<IapSyncResponse | null> {
  try {
    const res = await apiClient.post<IapSyncResponse>('/api/iap/sync', {});
    return res.data ?? null;
  } catch (err) {
    console.error('[IAP] Backend sync failed (will rely on webhook):', err);
    return null;
  }
}
